import '../themeDefaults';

export default ({ mobilegrid }) => ({
  root: {
    color: mobilegrid.noContentText,
    padding: 20,
    textAlign: 'center'
  }
});
